import React from 'react';

const Preloader = ({ text = "Loading..." }) => (
  <div style={{
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f4f8f8'
  }}>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      <div className="hex-loader" />
      <div style={{ marginTop: 40, fontWeight: 'bold', color: '#08b1c7', fontSize: 20 }}>
        {text}
      </div>
      <style>
        {`
          .hex-loader {
            width: 80px;
            height: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .hex-loader::before {
            content: "";
            display: block;
            width: 60px;
            height: 60px;
            background: #08b1c7;
            clip-path: polygon(
              25% 6.7%, 75% 6.7%,
              100% 50%, 75% 93.3%,
              25% 93.3%, 0% 50%
            );
            animation: hex-spin 1.2s linear infinite;
            box-shadow: 0 0 16px #08b1c755;
          }
          @keyframes hex-spin {
            100% { transform: rotate(360deg);}
          }
        `}
      </style>
    </div>
  </div>
);

export default Preloader;